"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useGetUser = _interopRequireDefault(require("./useGetUser"));
var _NotificationDot3 = _interopRequireDefault(require("./NotificationDot"));
var _jsxRuntime = require("react/jsx-runtime");
var _g, _NotificationDot, _NotificationDot2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const getImageSize = imgSize => {
  switch (imgSize) {
    case "tiny":
      return 12;
    case "large":
      return 50;
    default:
      return 30;
  }
};
const Image = /*#__PURE__*/_styledComponents.default.img.withConfig({
  displayName: "ProfileImage__Image",
  componentId: "sc-mwo2x5-0"
})(["position:relative;height:", "px;min-height:", "px;width:", "px;min-width:", "px;border-radius:", ";"], ({
  imgSize
}) => getImageSize(imgSize), ({
  imgSize
}) => getImageSize(imgSize), ({
  imgSize
}) => getImageSize(imgSize), ({
  imgSize
}) => getImageSize(imgSize), ({
  theme
}) => theme.orbit.borderRadiusCircle);
// Converted from svg with https://svg2jsx.com/
const AccountIcon = ({
  imgSize = "normal"
}) => {
  const size = getImageSize(imgSize);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    style: {
      width: `${size}px`,
      height: `${size}px`
    },
    "data-test": "TopNav-AccountIcon",
    children: _g || (_g = /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        fill: "#E8EDF1",
        transform: "translate(-80 -82)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(80 82)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M32 0c17.664 0 32 14.336 32 32S49.664 64 32 64 0 49.664 0 32 14.336 0 32 0zm.005 36.683c-12.56 0-21.333 6.578-21.333 16l.115.53.35.345c11.617 11.249 30.104 11.25 41.723.003l.353-.348.126-.53-.003-.307c-.188-9.257-8.905-15.693-21.33-15.693zm0-24c-5.882 0-10.666 4.786-10.666 10.666 0 5.88 4.786 10.667 10.666 10.667 5.883 0 10.667-4.787 10.667-10.667s-4.784-10.666-10.667-10.666z"
                })
              })
            })
          })
        })
      })
    }))
  });
};
const ProfileImage = ({
  imgSize = "normal",
  enableNotificationDot = false
}) => {
  var _user$displayName, _user$unreadMessages, _ref;
  const user = (0, _useGetUser.default)();
  const name = (_user$displayName = user === null || user === void 0 ? void 0 : user.displayName) !== null && _user$displayName !== void 0 ? _user$displayName : "";
  const url = user === null || user === void 0 ? void 0 : user.photo;
  const socialImageUrl = user === null || user === void 0 ? void 0 : user.socialAvatar;
  const [imgLoadError, setImageLoadError] = React.useState(false);
  const unreadMessages = (_user$unreadMessages = user === null || user === void 0 ? void 0 : user.unreadMessages) !== null && _user$unreadMessages !== void 0 ? _user$unreadMessages : 0;
  if (url == null && socialImageUrl == null || imgLoadError) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(AccountIcon, {
        imgSize: imgSize
      }), unreadMessages > 0 && enableNotificationDot && (_NotificationDot || (_NotificationDot = /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotificationDot3.default, {
        dataTest: "TopNav-NotificationDot"
      })))]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Image, {
      onError: () => setImageLoadError(true),
      imgSize: imgSize,
      src: (_ref = url !== null && url !== void 0 ? url : socialImageUrl) !== null && _ref !== void 0 ? _ref : "",
      alt: name
    }), unreadMessages > 0 && enableNotificationDot && (_NotificationDot2 || (_NotificationDot2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotificationDot3.default, {
      dataTest: "TopNav-NotificationDot"
    })))]
  });
};
var _default = ProfileImage;
exports.default = _default;